<div *ngIf="type() && type() === 'icons'">
    <label for="icons">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input multiple (change)="onIconsUpload($event)" type="file" id="icons" style="display: none" accept=".png">
    </label>
</div>

<div *ngIf="type() && type() === 'appIcon'">
    <label for="appIcon">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input (change)="onAppIconUpload($event)" type="file" id="appIcon" style="display: none" accept=".png">
    </label>
</div>